import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatDate } from '../../core/helpers';
import Button from '../Button';

import './OpenTask.scss';

interface Props {
  i: number;
  item: TodoItem;
  id: string;
  type: 'ongoing' | 'expired';
}

export interface TodoItem {
  label?: string;
  description: string;
  date: Date;
  action: string | (() => void);
  btnLabel: string;
  id: string;
}

export default function OpenTask({ i, item, id, type }: Props) {
  const { t } = useTranslation();

  return (
    <div className={`OpenTask OpenTask--${type} py-2 px-3`}>
      <div className='d-flex'>
        <div
          className='rounded-circle OpenTask__circle d-flex align-items-center justify-content-center px-2 py-1 me-2 fw-600'
          data-testid={`openTask-num-${id}`}
          style={{
            marginTop: 3,
          }}
        >
          {i + 1}
        </div>
        <div className='flex-grow-1'>
          <div className='d-flex align-items-center justify-content-between flex-wrap'>
            <div className='fw-600 me-3' data-testid={`openTask-label-${id}`}>
              {item.label}
            </div>
            <div
              className='d-flex align-items-center justify-content-between flex-grow-1'
              style={{
                maxWidth: 300,
              }}
            >
              <div data-testid={`openTask-date-${id}`}>
                {t('by *date*').replace(
                  '*date*',
                  formatDate(item.date, 'do MMMM')
                )}
              </div>
              <div className='ps-3'>
                {typeof item.action === 'string' ? (
                  <Link
                    className={classNames(
                      'Button--sm d-inline-block OpenTask__btn text-center',
                      {
                        'Button OpenTask__link': type === 'ongoing',
                        'Button--outline': type === 'expired',
                      }
                    )}
                    to={item.action}
                    data-testid={`openTask-link-${id}`}
                  >
                    {t(item.btnLabel)}
                  </Link>
                ) : (
                  <Button
                    styling={type === 'expired' ? 'outline' : 'primary'}
                    size='sm'
                    onClick={item.action}
                    data-testid={`openTask-btn-${id}`}
                    className='OpenTask__btn'
                  >
                    {t(item.btnLabel)}
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div
            className='Text--gray'
            data-testid={`openTask-description-${id}`}
          >
            {item.description}
          </div>
        </div>
      </div>
    </div>
  );
}
